var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3 5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19zM19.6 25.9c-3.16 0-6.2 1.44-7.98 3.61a6.68 6.68 0 0 0-1.6 3.97 6.22 6.22 0 0 0 1.66 4.37c2.8 3.2 7.26 5.15 13.62 5.15 6.36 0 10.83-1.95 13.62-5.15a6.22 6.22 0 0 0 1.65-4.37 6.68 6.68 0 0 0-1.6-3.97A10.51 10.51 0 0 0 31 25.9H19.6z",
    fill: "#fff"
  })));
});